module.exports = __webpack_public_path__ + "static/media/ic_eraser_selected.c1e562fe.svg";